module.exports = __webpack_public_path__ + "std/img/Group.d69472b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/sign/Group.png
// module id = zE5S
// module chunks = 0